import requests from "./api/base-api";

const NotificationService = {
  NotificationList: (body) =>
    requests.get("/notification/v1/get-notification-list-user", body),

  getNotifById: (id) =>
    requests.get(`/notification/v1/get-detail-notification-user/${id}`),
};

export default NotificationService;
